var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "product-section"
  }, [_c('div', {
    staticClass: "mt-0"
  }, [_c('advertisement-top-banner-text'), _vm.$options.components['advertisement-loading'] ? [_vm.isLoading ? _c('advertisement-loading') : _vm._e()] : _vm._e(), _c('div', {
    staticClass: "container mt-3"
  }, [_vm.productData ? _c('b-row', {
    staticClass: "product-main my-3"
  }, [_c('b-col', {
    staticClass: "product-border product-images",
    attrs: {
      "md": "5"
    }
  }, [_vm.productData['Discount'] || _vm.productData['Discount(%)'] ? _c('div', {
    staticClass: "show-variant"
  }, [_vm.productData['Discount'] ? _c('span', {
    staticClass: "variant-span text-icon price-normal"
  }, [_vm._v(" " + _vm._s(_vm.currency.symbol) + " " + _vm._s(_vm.productData["Discount"]) + " off ")]) : _vm._e()]) : _vm._e(), _c('b-row', {
    staticClass: "flex-column align-items-center"
  }, [_c('b-col', {
    staticClass: "text-center",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "align-items-center"
  }, [_c('b-img', {
    staticClass: "product-main-image my-3",
    attrs: {
      "id": "product-img-1",
      "src": _vm.imagesArr[_vm.activeBox],
      "alt": "",
      "height": "320",
      "width": "260"
    }
  })], 1)]), _c('b-col', {
    staticClass: "d-flex justify-content-center",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "d-flex product-thumbnails"
  }, _vm._l(_vm.imagesArr, function (product, i) {
    return _c('div', {
      key: i,
      staticClass: "productdetail-imgshort mx-2",
      on: {
        "mouseover": function ($event) {
          return _vm.setActiveBox(i);
        }
      }
    }, [_c('b-img', {
      staticClass: "product-thumb-image",
      class: [i === _vm.activeBox ? 'box-hovered' : 'box-common'],
      attrs: {
        "src": product,
        "center": "",
        "height": "100",
        "width": "100",
        "id": "product-img-1"
      }
    })], 1);
  }), 0)])], 1)], 1), _c('b-col', {
    staticClass: "product-info pr-0 pl-3",
    attrs: {
      "md": "7"
    }
  }, [_c('v-breadcrumbs', [_c('div', [_c('span', {
    staticClass: "product-address",
    on: {
      "click": function ($event) {
        return _vm.$router.push(`${_vm.items.href}`);
      }
    }
  }, [_vm._v(_vm._s(_vm.items.text))]), _c('v-icon', [_vm._v("mdi-chevron-right")]), _c('span', {
    staticClass: "product-address",
    on: {
      "click": function ($event) {
        return _vm.$router.push(`/category/${_vm.productData.Category}`);
      }
    }
  }, [_vm._v(_vm._s(`${_vm.productData.Category}`))]), _c('v-icon', [_vm._v("mdi-chevron-right")]), _c('span', {
    staticClass: "text-no-href"
  }, [_vm._v(_vm._s(`${_vm.productData.Name}`))])], 1)]), _vm.productData.Name || _vm.productData.Quantity ? _c('h1', {
    staticClass: "product-name"
  }, [_vm._v(" " + _vm._s(_vm.productData.Name) + " ")]) : _vm._e(), _c('div', {
    staticClass: "d-flex mt-3 justify-content-between justify-content-sm-between align-items-center product-price"
  }, [_vm.productData['Discount(%)'] || _vm.productData['Discount'] ? _c('div', {
    staticClass: "price-del-width"
  }, [_c('del', {
    staticClass: "text-icon price mb-0 mr-3"
  }, [_vm._v(_vm._s(_vm.currency.symbol) + " " + _vm._s(Number(_vm.productData.Price).toFixed(2)) + " ")]), _c('h1', {
    staticClass: "text-icon price mb-0 margin-left-8"
  }, [_vm._v(" " + _vm._s(_vm.currency.symbol) + " " + _vm._s(Number(_vm.productData["Deal Price"]).toFixed(2)) + " | " + _vm._s(_vm.productData.Quantity) + " ")])]) : _vm._e(), !_vm.productData['Discount'] && !_vm.productData['Discount(%)'] ? _c('div', {
    staticClass: "price-container"
  }, [_c('div', {
    staticClass: "price-left"
  }, [_c('span', {
    staticClass: "price-amount"
  }, [_vm._v(" " + _vm._s(_vm.currency.symbol) + " " + _vm._s(Number(_vm.productData.Price).toFixed(2)) + " ")])]), _vm.productData.Quantity ? _c('div', {
    staticClass: "quantity-container"
  }, [_c('span', {
    staticClass: "quantity-text"
  }, [_vm._v(" " + _vm._s(_vm.productData.Quantity) + " ")])]) : _vm._e()]) : _vm._e()]), _vm.productVariants && _vm.productVariants.length ? _c('div', {
    staticClass: "mb-2",
    attrs: {
      "id": "unit-button-box"
    }
  }, _vm._l(_vm.productVariants, function (variant) {
    return _c('button', {
      key: variant._id,
      class: {
        selectedUnit: _vm.activeVariant(_vm.productData, variant.attributes)
      },
      on: {
        "click": function ($event) {
          return _vm.selectUnit(variant);
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.getVariantName(variant.attributes)) + " ")]);
  }), 0) : _vm._e(), _c('hr'), _vm.productData.Availability && _vm.productData.Availability.toLowerCase().trim() === 'out of stock' ? _c('div', {
    staticClass: "text-center"
  }, [_c('p', {
    staticClass: "text-danger font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.$t("wishlistProduct.availability.outOfStock")) + " ")])]) : _c('div', {
    staticClass: "d-flex align-items-center mb-2"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('div', {
    staticClass: "add-button add-button-mobile",
    attrs: {
      "id": "add-cart"
    }
  }, [_vm.$options.components['checkout-increment-decrement'] ? [_c('checkout-increment-decrement', {
    attrs: {
      "callCheckout": true,
      "cartItem": _vm.productData,
      "bigButtonClass": 'product-add big-button btn-primary w-100',
      "showGoToCart": true
    }
  })] : _vm._e()], 2), _c('div', {
    staticClass: "product-icon-circle pointer heart"
  }, [_vm.wishlistKey ? _c('b-icon', {
    attrs: {
      "size": "xl",
      "icon": "heart-fill"
    },
    on: {
      "click": function ($event) {
        return _vm.removeItem(_vm.productData);
      }
    }
  }) : _c('b-icon', {
    attrs: {
      "size": "xl",
      "icon": "heart"
    },
    on: {
      "click": function ($event) {
        return _vm.addToWishlist(_vm.productData);
      }
    }
  })], 1)])]), _c('hr'), _vm.productData.providerName ? _c('div', {
    staticClass: "d-flex"
  }, [_c('dt', {
    staticClass: "mr-1"
  }, [_vm._v(_vm._s(_vm.$t("provider")) + " :")]), _c('dt', [_c('router-link', {
    attrs: {
      "to": ""
    }
  }, [_vm._v(_vm._s(_vm.productData.providerName))])], 1)]) : _vm._e(), _c('div', {
    staticClass: "product-details"
  }, [_c('dt', [_vm._v(_vm._s(_vm.$t("productDetails")) + " :")]), _vm.productData.Name ? _c('dd', [_vm._v(" " + _vm._s(_vm.$t("productName")) + " : " + _vm._s(_vm.productData.Name) + " ")]) : _vm._e(), _vm.productData && _vm.productData.City && _vm.productData.State ? _c('dd', [_vm._v(" " + _vm._s(_vm.$t("city")) + " : " + _vm._s(_vm.productData.City) + " " + _vm._s(_vm.productData.State) + " ")]) : _vm._e(), _vm.productData && _vm.productData.Description ? _c('dd', [_vm._v(" " + _vm._s(_vm.productData.Description) + " ")]) : _vm._e()])], 1)], 1) : _vm._e(), _vm._m(0), _c('b-card', [_c('b-row', {
    staticClass: "align-items-center"
  }, [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('div', {
    staticClass: "text-left"
  }, [_c('h6', [_vm._v(" Overall Rating "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(" + _vm._s(_vm.ratingCount) + ")")])]), _c('div', {
    staticClass: "text-warning h4"
  }, [_vm._l(Math.floor(_vm.ratingAverage), function (n) {
    return _c('b-icon', {
      key: 'full-' + n,
      staticClass: "text-warning",
      attrs: {
        "icon": "star-fill"
      }
    });
  }), _vm.ratingAverage % 1 >= 0.5 ? _c('b-icon', {
    staticClass: "text-warning",
    attrs: {
      "icon": "star-half"
    }
  }) : _vm._e(), _vm._l(5 - Math.ceil(_vm.ratingAverage), function (n) {
    return _c('b-icon', {
      key: 'empty-' + n,
      staticClass: "text-warning",
      attrs: {
        "icon": "star"
      }
    });
  })], 2)])]), _c('b-col', {
    attrs: {
      "md": "5"
    }
  }, _vm._l([5, 4, 3, 2, 1], function (star) {
    return _c('div', {
      key: star,
      staticClass: "d-flex align-items-center mb-1"
    }, [_c('span', {
      staticStyle: {
        "width": "60px"
      }
    }, [_vm._v(" " + _vm._s(star) + " "), _c('b-icon', {
      staticClass: "text-warning ml-2",
      attrs: {
        "icon": "star-fill"
      }
    })], 1), _c('b-progress', {
      staticClass: "flex-grow-1",
      attrs: {
        "value": _vm.getRatingPercentage(star),
        "max": 100,
        "height": "12px",
        "variant": "success"
      }
    })], 1);
  }), 0), _c('b-col', {
    attrs: {
      "md": "4"
    }
  })], 1), _c('h6', {
    staticClass: "mt-4"
  }, [_c('strong', [_vm._v("Customer Review Summary")])]), _vm.allRatings.length > 0 ? _c('div', _vm._l(_vm.displayedReviews, function (review, index) {
    return _c('div', {
      key: index,
      staticClass: "mb-4"
    }, [_c('b-card', {
      staticClass: "shadow-sm"
    }, [_c('b-row', [_c('b-col', {
      attrs: {
        "md": "1"
      }
    }, [_c('b-avatar', {
      attrs: {
        "src": review.avatar,
        "size": "48px"
      }
    })], 1), _c('b-col', {
      attrs: {
        "md": "11"
      }
    }, [_c('b-row', [_c('b-col', {
      attrs: {
        "md": "6"
      }
    }, [_c('div', {
      staticClass: "d-flex justify-content-start align-items-center"
    }, [_c('h6', {
      staticClass: "mb-1 mr-2"
    }, [_vm._v(_vm._s(review.name))]), _c('small', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(review.date))])]), _c('div', {
      staticClass: "text-warning mb-2"
    }, [_vm._l(review.rating, function (n) {
      return _c('b-icon', {
        key: `f-${n}`,
        attrs: {
          "icon": "star-fill"
        }
      });
    }), _vm._l(5 - review.rating, function (n) {
      return _c('b-icon', {
        key: `e-${n}`,
        attrs: {
          "icon": "star"
        }
      });
    })], 2), _c('p', {
      staticClass: "text-muted mb-2"
    }, [_vm._v(_vm._s(review.comment))]), _c('div', {
      staticClass: "badgeMain"
    }, _vm._l(review.tags, function (tag, i) {
      return _c('b-badge', {
        key: i,
        staticClass: "mr-1",
        attrs: {
          "variant": "info"
        }
      }, [_vm._v(" " + _vm._s(tag) + " ")]);
    }), 1)]), _c('b-col', {
      attrs: {
        "md": "6"
      }
    }, [_c('b-row', _vm._l(review.media, function (media, i) {
      return _c('b-col', {
        key: i,
        attrs: {
          "cols": "3"
        }
      }, [_c('b-img', {
        staticClass: "product-image",
        attrs: {
          "src": media.url,
          "thumbnail": "",
          "fluid": ""
        },
        on: {
          "click": function ($event) {
            return _vm.openImageModal(media.url);
          }
        }
      })], 1);
    }), 1), _c('b-modal', {
      attrs: {
        "id": "image-viewer-modal",
        "size": "lg",
        "centered": "",
        "hide-footer": ""
      },
      model: {
        value: _vm.showImageModal,
        callback: function ($$v) {
          _vm.showImageModal = $$v;
        },
        expression: "showImageModal"
      }
    }, [_c('div', {
      staticClass: "text-center imgPopup"
    }, [_c('b-img', {
      attrs: {
        "src": _vm.selectedImageUrl,
        "fluid": ""
      }
    })], 1)])], 1)], 1), _c('b-row', [_c('b-col', {
      attrs: {
        "md": "6"
      }
    }), _c('b-col', {
      attrs: {
        "md": "6"
      }
    }, [review.sellerResponses && review.sellerResponses.length ? _c('div', _vm._l(review.sellerResponses, function (res, idx) {
      return _c('b-card', {
        key: idx,
        staticClass: "mb-2 sellerCard",
        attrs: {
          "bg-variant": "light",
          "border-variant": "muted",
          "text-variant": "dark"
        }
      }, [_c('small', [_c('strong', {
        staticClass: "mr-1"
      }, [_vm._v(_vm._s(res.by) + "(Seller)")]), _vm._v(" " + _vm._s(res.date) + " ")]), _c('p', {
        staticClass: "mb-0"
      }, [_vm._v(_vm._s(res.message))])]);
    }), 1) : _vm._e()])], 1)], 1)], 1)], 1)], 1);
  }), 0) : _c('div', {
    staticClass: "text-center py-4 text-muted"
  }, [_vm._v(" No reviews available. ")]), _vm.allRatings.length > 3 ? _c('div', {
    staticClass: "text-center"
  }, [_c('b-button', {
    staticClass: "px-5",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.toggleReviewView
    }
  }, [_vm._v(" " + _vm._s(_vm.showAllReviews ? "Show Less" : "View All") + " ")])], 1) : _vm._e()], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "lg": "12",
      "md": "12",
      "sm": "12"
    }
  }, [_c('b-tabs', {
    attrs: {
      "content-class": "",
      "nav-class": "justify-content-center"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": _vm.$t('description')
    }
  }, [_c('div', {
    staticClass: "product-description"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t("productDescription")))]), _c('div', {
    staticClass: "description-content"
  }, [_c('p', [_vm._v(" " + _vm._s(_vm.productData && _vm.productData.Description ? _vm.productData.Description : "") + " ")])])])]), _c('b-tab', {
    attrs: {
      "title": _vm.$t('additionalInformation')
    }
  }, [_c('div', {
    staticClass: "product-description"
  }, [_c('h5', {
    staticClass: "section-title"
  }, [_vm._v(" " + _vm._s(_vm.$t("additionalInformation")) + " ")]), _c('div', {
    staticClass: "info-grid"
  }, [_vm.productData && _vm.productData.Quantity ? _c('div', {
    staticClass: "info-item"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v(_vm._s(_vm.$t("quantity")) + ":")]), _c('span', {
    staticClass: "info-value"
  }, [_vm._v(_vm._s(_vm.productData.Quantity))])]) : _vm._e(), _vm.productData && _vm.productData.Availability ? _c('div', {
    staticClass: "info-item"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v(" " + _vm._s(_vm.$t("stockStatus")) + ":")]), _c('span', {
    staticClass: "info-value"
  }, [_vm._v(_vm._s(_vm.productData.Availability))])]) : _vm._e(), _vm.productData && _vm.productData.Category ? _c('div', {
    staticClass: "info-item"
  }, [_c('span', {
    staticClass: "info-label"
  }, [_vm._v(_vm._s(_vm.$t("category.category")) + ":")]), _c('span', {
    staticClass: "info-value"
  }, [_vm._v(_vm._s(_vm.productData.Category))])]) : _vm._e(), _vm.productData && _vm.productData.tags && _vm.productData.tags.length ? _c('div', {
    staticClass: "info-item tags-container"
  }, [_c('span', {
    staticClass: "info-label pb-2"
  }, [_vm._v(_vm._s(_vm.$t("tags")) + " :")]), _c('div', {
    staticClass: "tags-wrapper"
  }, _vm._l(_vm.productData.tags, function (tag) {
    return _c('span', {
      key: tag,
      staticClass: "tag-badge"
    }, [_vm._v(" " + _vm._s(tag) + " ")]);
  }), 0)]) : _vm._e()])])])], 1)], 1)], 1)], 1), _vm.relatedItems && _vm.relatedItems.length ? _c('sections-slider', {
    staticClass: "suggested-slider",
    attrs: {
      "list": _vm.relatedItems,
      "subTitle": _vm.$t('relatedProducts'),
      "hasBackground": true,
      "showTitle": true,
      "hasButton": false,
      "withoutSlider": true,
      "maxItems": 4
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var listItem = _ref.listItem;
        return [_c('div', {
          staticClass: "item-box"
        }, [_c('items-item', {
          staticClass: "suggester-div card-hover",
          attrs: {
            "itemNoBg": true,
            "product": listItem,
            "incrementDecrementKey": true
          }
        })], 1)];
      }
    }], null, false, 1880832656)
  }) : _vm._e()], 2)]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('h5', [_c('strong', [_vm._v("Customer Review")])]);

}]

export { render, staticRenderFns }